module.exports = __webpack_public_path__ + "media/images/global/icons/attend-e12c8dbc394be927fedaee7bcb61764c.svg";